import React, { useEffect, useState } from 'react';
import { User } from 'lucide-react';
import UserMenu from './UserMenu';
import NotificationsDropdown from './NotificationsDropdown';
import ThemeToggle from './ThemeToggle';
import { Movie } from '../types';

interface NavbarProps {
  session: any;
  onSignIn: () => void;
  onSignOut: () => void;
  onNavigate: (page: string) => void;
  tenantLogoUrl?: string;
  isTenant?: boolean;
  onContinuePending?: (movie: Movie, screeningId: number, bookingId: number, seatIds: string[]) => Promise<void> | void;
}

export default function Navbar({ session, onSignIn, onSignOut, onNavigate, tenantLogoUrl, isTenant, onContinuePending }: NavbarProps) {
  const [showBrand, setShowBrand] = useState(true);
  useEffect(() => {
    if (!isTenant) return;
    const id = setInterval(() => setShowBrand((v) => !v), 4000);
    return () => clearInterval(id);
  }, [isTenant]);
  const scrollToMovies = () => {
    onNavigate('home');
    setTimeout(() => {
      const moviesSection = document.getElementById('movies-section');
      moviesSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  };

  return (
    <header className="navbar fixed top-0 left-0 right-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center space-x-8">
            <div className="flex items-center group cursor-pointer" onClick={() => onNavigate('home')}>
              {isTenant && tenantLogoUrl ? (
                <div className="brand-fade-container">
                  <h1
                    className={`text-2xl font-bold urbanist-brand bg-gradient-to-r from-black to-gray-700 dark:bg-gradient-to-r dark:from-white dark:to-gray-500 bg-clip-text text-transparent absolute inset-0 flex items-center transition-opacity duration-700 ${showBrand ? 'opacity-100' : 'opacity-0'}`}
                  >
                    Eventador
                  </h1>
                  <img
                    src={tenantLogoUrl}
                    alt="Organizer"
                    className={`h-10 w-auto absolute inset-0 transition-opacity duration-700 ${showBrand ? 'opacity-0' : 'opacity-100'}`}
                  />
                </div>
              ) : (
                <h1 className="text-2xl font-bold urbanist-brand bg-gradient-to-r from-black to-gray-700 dark:bg-gradient-to-r dark:from-white dark:to-gray-500 bg-clip-text text-transparent">
                  Eventador
                </h1>
              )}
            </div>
            <button
              onClick={scrollToMovies}
              className="text-gray-700 hover:text-gray-900 dark:text-gray-300 dark:hover:text-white transition-colors duration-300 font-medium"
            >
              Movies
            </button>
            {/* <button
              onClick={() => onNavigate('weddings/messages')}
              className="text-gray-700 hover:text-gray-900 dark:text-gray-300 dark:hover:text-white transition-colors duration-300 font-medium"
            >
              Messages
            </button>
            <button
              onClick={() => onNavigate('weddings')}
              className="text-gray-700 hover:text-gray-900 dark:text-gray-300 dark:hover:text-white transition-colors duration-300 font-medium"
            >
              Weddings
            </button> */}
            {!isTenant && (
              <button
                onClick={() => onNavigate('organizers')}
                className="text-gray-700 hover:text-gray-900 dark:text-gray-300 dark:hover:text-white transition-colors duration-300 font-medium"
              >
                Organizers
              </button>
            )}
          </div>
          <div className="flex items-center gap-4">
            <ThemeToggle />
            {session ? (
              <>
                <NotificationsDropdown userId={session.user.id} />
                <UserMenu
                  userEmail={session.user.email}
                  userId={session.user.id}
                  onSignOut={onSignOut}
                  onNavigate={onNavigate}
                  onContinuePending={onContinuePending}
                />
              </>
            ) : (
              <>
                <button
                  onClick={onSignIn}
                  className="hidden sm:inline-flex items-center px-4 py-2 rounded-md text-sm font-medium bg-gray-800 text-white hover:bg-gray-700 transition-all duration-300 animate-glow"
                >
                  Sign In
                </button>
                <button
                  onClick={onSignIn}
                  aria-label="Sign in"
                  className="inline-flex sm:hidden items-center justify-center w-9 h-9 rounded-full bg-gray-800 text-white hover:bg-gray-700 transition-all duration-300 animate-glow"
                >
                  <User className="h-5 w-5" />
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
